import * as MyKeysApi from './index';
import { MyKeysPromise } from '../../../interfaces';
import { ServerSettings } from '../../../contexts/settings.context';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const getDeviceSettings = (): MyKeysPromise<ServerSettings> => {
  Logger.info(['POST: Device Settings Requested'], LogArea.Api);
  return MyKeysApi.get('configuration/getSettings', true)
    .then((res) => MyKeysApi.Map.mapDeviceSettingsDto(res.data))
    .catch(MyKeysApi.parseError);
};

export const updateCtx = (): MyKeysPromise<boolean> => {
  Logger.info(['POST: Update Context Requested'], LogArea.Api);
  return MyKeysApi.post('configuration/UpdateCustomerAndUserLogin', {}, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};
